import HelpdeskTramite from "model/helpdesk/HelpdeskTramite";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { ScrollPanel } from "primereact/scrollpanel";
import saveAs from 'file-saver';
import { useState } from "react";
import Lightbox from "react-image-lightbox";

type Props = {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    helpdeskTramite: HelpdeskTramite | null;
}

export default function HelpdeskModalImagemTramite(props: Props) {

    const [photoOpen, setPhotoOpen] = useState<boolean>(false);
    const [urlOpened, setUrlOpened] = useState<string>('');

    return (
        <>
            {photoOpen && (
                <Lightbox
                    mainSrc={urlOpened}
                    onCloseRequest={() => setPhotoOpen(false)}
                    reactModalStyle={{ overlay: { zIndex: 9999 } }}
                />
            )}
            <Dialog header="Anexos" visible={props.visible} baseZIndex={500} style={{ width: '50vw' }} onHide={() => props.setVisible(false)}>
                <div className="col-sm-12" style={{ marginTop: 8 }}>
                    <DataTable
                        header={null}
                        value={props.helpdeskTramite?.arquivos ? props.helpdeskTramite?.arquivos.filter(f => f.ativo) : []}
                        emptyMessage='Nenhum anexo'
                    >
                        <Column field="nome" header="Anexos"
                            className='coluna-nome'
                            body={(rowData) => rowData.id > 0 ? rowData.remover ?
                                <span><s>{rowData.nome}</s></span>
                                : <a
                                    style={{ color: '#3CA4FF', textDecoration: 'underline', textDecorationColor: '#3CA4FF', cursor: 'pointer' }}
                                    onClick={() => {
                                        fetch(rowData.url)
                                            .then(res => res.blob())
                                            .then(blob => saveAs(blob, rowData.nome))
                                            .catch(e => {
                                                console.error(e)
                                            });
                                        return false;
                                    }}>{rowData.nome}</a> : rowData.nome}>
                        </Column>
                    </DataTable>
                </div>
            </Dialog>
        </>
    )
}